import React from 'react';
import SaveIcon from '../Icons/SaveIcon'
const SaveButton = ({
    onClick,
    disabled,
    type,
    bgColor,
    text
}) => {
    return (
        <div className="px-1 w-full text-center my-2">
            <button type={type} onClick={onClick} disabled={disabled} style={{ backgroundColor: bgColor }} className="h-8 bg-cyan-600 text-gray-300 font-normal rounded hover:bg-cyan-500  hover:text-white shadow-md py-1 px-2 inline-flex items-center w-full">
                {!bgColor && <SaveIcon />}
                <span className="px-1 pb-1 text-sm font-normal w-full">{text || "حفظ"}</span>
            </button>
        </div>
    );
};

export default SaveButton;